import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Phone, Mail } from "lucide-react";
import { LOGO, ADDRESS } from "../../lib/images";

export const Footer = ({ settings }) => {
  const s = settings || {};
  const hours = s.hours || {};
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${ADDRESS.mapsQuery}`;

  return (
    <footer className="bg-hb-black border-t border-hb-line relative grain" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10">
        <div className="md:col-span-1">
          <img src={LOGO} alt="Hackberry Home" className="h-20 w-20 object-contain logo-invert mb-4" />
          <p className="font-serif text-2xl text-hb-cream leading-none">Hackberry Home</p>
          <p className="eyebrow text-hb-brass text-[0.62rem] mt-2">Southern Scratch Made Kitchen</p>
          <div className="mt-5 flex items-start gap-2 text-hb-muted text-sm">
            <MapPin size={16} className="mt-0.5 shrink-0 text-hb-brass" />
            <span>{ADDRESS.line1}<br />{ADDRESS.cityStateZip}</span>
          </div>
        </div>

        <div>
          <p className="eyebrow text-hb-brass mb-5">Explore</p>
          <ul className="space-y-3 text-hb-muted text-sm">
            <li><Link to="/" className="hover:text-hb-cream transition-colors">Home</Link></li>
            <li><Link to="/menu" className="hover:text-hb-cream transition-colors">Menu</Link></li>
            <li><Link to="/about" className="hover:text-hb-cream transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-hb-cream transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <p className="eyebrow text-hb-brass mb-5">Hours</p>
          <ul className="space-y-2 text-sm">
            {Object.entries(hours).map(([day, val]) => (
              <li key={day} className="flex justify-between gap-4 text-hb-muted">
                <span>{day}</span>
                <span className={val === "Closed" ? "text-hb-mutedlight" : "text-hb-cream"}>{val}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow text-hb-brass mb-5">Get In Touch</p>
          <ul className="space-y-3 text-sm text-hb-muted">
            {s.phone && (
              <li className="flex items-center gap-2">
                <Phone size={15} className="text-hb-brass" />
                <a href={`tel:${(s.phone || "").replace(/[^0-9+]/g, "")}`} className="hover:text-hb-cream transition-colors">{s.phone}</a>
              </li>
            )}
            {s.email && (
              <li className="flex items-center gap-2">
                <Mail size={15} className="text-hb-brass" />
                <a href={`mailto:${s.email}`} className="hover:text-hb-cream transition-colors">{s.email}</a>
              </li>
            )}
          </ul>
          <div className="flex gap-3 mt-6">
            {s.facebook && (
              <a href={s.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook"
                 className="h-10 w-10 border border-hb-line flex items-center justify-center text-hb-cream hover:border-hb-brass hover:text-hb-brass transition-colors">
                <Facebook size={18} />
              </a>
            )}
            {s.instagram && (
              <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram"
                 className="h-10 w-10 border border-hb-line flex items-center justify-center text-hb-cream hover:border-hb-brass hover:text-hb-brass transition-colors">
                <Instagram size={18} />
              </a>
            )}
            <a href={directions} target="_blank" rel="noreferrer" aria-label="Directions"
               className="h-10 w-10 border border-hb-line flex items-center justify-center text-hb-cream hover:border-hb-brass hover:text-hb-brass transition-colors">
              <MapPin size={18} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-hb-line py-6 text-center relative z-10">
        <p className="text-hb-mutedlight text-xs eyebrow">© Hackberry Home. All Rights Reserved.</p>
      </div>
    </footer>
  );
};
